
export const enum SheetCellTypes {
  number = 'TYPE_NUMBER',
  string = 'TYPE_STRING',
  date = 'TYPE_DATE',
  time = 'TYPE_TIME',
  formula = 'TYPE_FORMULA',
  date_interval = 'TYPE_DATE_INTERVAL',
  number_interval = 'TYPE_NUMBER_INTERVAL',
  list_interval = 'TYPE_LIST_INTERVAL',
  list_handbook = 'TYPE_LIST_HANDBOOK',
  list_cell = 'TYPE_LIST_CELL',
  drop_list = 'TYPE_DROP_LIST',
  schedule = 'TYPE_SCHEDULER',
}

export const enum SheetCellDepsTypes {
  some = 'TYPE_SOME',
  every = 'TYPE_EVERY',
}

export const DEPENDENCE_EMPTY_VALUE = '[Не выбрано]'

export const enum SheetCellTypeMethods {
  manual = 'METHOD_MANUAL',
  auto_start = 'METHOD_AUTO_START',
  list = 'METHOD_LIST',
  dep_list = 'METHOD_DEP_LIST',
  date_interval = 'METHOD_DATE_INTERVAL',
  number_interval = 'METHOD_NUMBER_INTERVAL',
}

export const SheetCellDepsTypeOptions = {
  [SheetCellDepsTypes.some]: {
    label: 'Любое из полей',
    value: SheetCellDepsTypes.some,
  },
  [SheetCellDepsTypes.every]: {
    label: 'Каждое поле',
    value: SheetCellDepsTypes.every,
  },
}

export const SheetCellTypeMethodOptions = {
  manual: {
    label: 'Ручной',
    value: SheetCellTypeMethods.manual,
  },
  auto_start: {
    label: 'Автоматический',
    value: SheetCellTypeMethods.auto_start,
  },
  date_interval: {
    label: 'Интервал',
    value: SheetCellTypeMethods.date_interval,
  },
  number_interval: {
    label: 'Интервал',
    value: SheetCellTypeMethods.number_interval,
  },
  list: {
    label: 'Из списка',
    value: SheetCellTypeMethods.list,
  },
  dep_list: {
    label: 'Зависимый список',
    value: SheetCellTypeMethods.dep_list,
  },
}

export const SheetCellTypesOptions = {
  number: {
    label: 'Число',
    value: SheetCellTypes.number,
    children: [
      SheetCellTypeMethodOptions.manual,
      SheetCellTypeMethodOptions.auto_start,
      SheetCellTypeMethodOptions.number_interval,
      SheetCellTypeMethodOptions.dep_list,
    ],
  },
  string: {
    label: 'Строка',
    value: SheetCellTypes.string,
    children: [
      SheetCellTypeMethodOptions.manual,
      SheetCellTypeMethodOptions.dep_list,
    ],
  },
  date: {
    label: 'Дата',
    value: SheetCellTypes.date,
    children: [
      SheetCellTypeMethodOptions.manual,
      SheetCellTypeMethodOptions.date_interval,
    ],
  },
  time: {
    label: 'Время',
    value: SheetCellTypes.time,
    children: [
      SheetCellTypeMethodOptions.manual,
    ],
  },
  formula: {
    label: 'Формула',
    value: SheetCellTypes.formula,
    children: [
    ],
  },
  date_interval: {
    label: 'Заполнение из интервала дат',
    value: SheetCellTypes.date_interval,
    children: [
    ],
  },
  number_interval: {
    label: 'Заполнение из интервала чисел',
    value: SheetCellTypes.number_interval,
    children: [
    ],
  },
  list_interval: {
    label: 'Заполнение строк из списка',
    value: SheetCellTypes.list_interval,
    children: [
    ],
  },
  list_handbook: {
    label: 'Заполнение из справочника',
    value: SheetCellTypes.list_handbook,
    children: [
    ],
  },
  cell_interval: {
    label: 'Заполнение из колонки',
    value: SheetCellTypes.list_cell,
    children: [
    ],
  },
  drop_list: {
    label: 'Из списка',
    value: SheetCellTypes.drop_list,
    children: [
    ],
  },
  schedule: {
    label: 'Расписание',
    value: SheetCellTypes.schedule,
    children: [
    ],
  },
}

export interface FormTemplate {
  name: string;
  id: number;
  created_at: string;
  updated_at: string;
}

export interface FormTemplateCount {
  data: {
    count: number;
  };
}

export interface FormTemplateCollection extends FormTemplate {
}
